function openChild(parameter) {
	var html = jQuery('#'+parameter).html();
	jQuery('#sub-container-content').html(html);
	jQuery('#main-container').addClass('sub_menu_active');
	jQuery('#sub-container').addClass('menu_active');
} 


jQuery(document).ready(function() {
	//sticky-header

	jQuery(window).scroll(function(){
		var sticky = jQuery('.site-header'),
			scroll = jQuery(window).scrollTop();
	
		if (scroll >= 300) sticky.addClass('nav-fixed');
		else sticky.removeClass('nav-fixed');


		var sticky_page = jQuery('.Wrapper');
		if (scroll >= 300) sticky_page.addClass('sticky-wrapper');
		else sticky_page.removeClass('sticky-wrapper');
	});

	jQuery(window).on('load', function() {
		jQuery('#raresipsModal').modal('show');
	});
	jQuery('.head_cart_button').on('click', function(){
		jQuery('#cart-sidebar').addClass('active');
		jQuery('.overlay').addClass('active');
	});
	jQuery('.cart-sidebar-close').on('click', function(){
		jQuery('#cart-sidebar').removeClass('active');
		jQuery('.overlay').removeClass('active');
	});
	jQuery('#open_menu').on('click', function(){
		jQuery('#mySidenav').addClass('active');
		jQuery('.overlay').addClass('active');
		jQuery('#closeBtn').show();
	});
	jQuery('#closeBtn').on('click', function(){
		jQuery('#mySidenav').removeClass('active');
		jQuery('.overlay').removeClass('active');
		jQuery('#closeBtn').hide();
	});
	jQuery('#mainMenu').on('click', function(){
		jQuery('#main-container').removeClass('sub_menu_active');
		jQuery('#sub-container').removeClass('menu_active');
	});
	jQuery('#Overlay').on('click', function(){
		jQuery('#main-container').removeClass('sub_menu_active');
		jQuery('#sub-container').removeClass('menu_active');
		jQuery('.overlay').removeClass('active');
		jQuery('#mySidenav').removeClass('active');
		jQuery('#cart-sidebar').removeClass('active');
		jQuery('#closeBtn').hide();
	});
	
	
	jQuery('#top_shipping_slider').slick({
		dots: false,
		arrows: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	jQuery('#key-notes').slick({
		dots: false,
		arrows: false,
		slidesToShow: 5,
		slidesToScroll: 1,
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 5000,
		center: true,
		responsive: [
			{
				breakpoint: 1300,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	jQuery('#promo-bar').slick({
		dots: false,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 5000,
	});

	jQuery('.filter_widget_title').on('click', function(){
		jQuery(this).next().slideToggle();
		jQuery(this).toggleClass('filter_menu_open');
	});
	
    jQuery("#slider_banner").owlCarousel({
		items:1,
		loop:true,
		nav:true,
		dots:false,
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		slideSpeed: 300,
    });
	jQuery("#online_stores").owlCarousel({
		navigation : true,
		items:8,
		margin:64,
		loop:false,
		dots:false,
		nav:false,
		autoplay:true,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:4,
				dots:false,
				margin:24,
			},
			992:{
				margin:40,
			}
		}
	});

    var owl = jQuery("#top-brands");
    
    function initOwl() {
        if (jQuery(window).width() < 768) {
            if (!owl.hasClass("owl-loaded")) {
                owl.addClass("owl-loaded").owlCarousel({
                    navigation : true,
            		items:8,
            		margin:64,
            		loop:false,
            		dots:false,
            		nav:false,
            		autoplay:true,
            		autoplayTimeout:3000,
            		autoplayHoverPause:true,
            		autoHeight: false,
            		responsive:{
            			0:{
            				items:4,
            				dots:false,
            				margin:24,
            			},
            			992:{
            				margin:40,
            			}
            		}
                });
            }
        } else {
            if (owl.hasClass("owl-loaded")) {
                owl.trigger("destroy.owl.carousel").removeClass("owl-loaded");
                owl.find(".owl-stage-outer").children().unwrap();
            }
        }
    }

    // Initialize on load
    initOwl();

    // Re-check on window resize
    jQuery(window).resize(function () {
        initOwl();
    });


  
	jQuery("#featured_in_logos").owlCarousel({
		navigation : true,
		items:8,
		margin:64,
		loop:false,
		dots:false,
		nav:false,
		autoplay:true,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:4,
				dots:false,
				margin:24,
			},
			992:{
				margin:40,
			}
		}
	});


    
  jQuery('#influencers').owlCarousel({
      loop:true,
      margin:20,
      nav:false,
      dots:false,
      center: true,
      autoplay:false,
      autoplayTimeout:3000,
      autoplayHoverPause:false,
      responsiveClass:true,
      responsive:{
        0:{
          items:1.55,
          nav:true,
          },
        575:{
        items:2.55,
        nav:true,
        },
        992:{
        items:3.40,
        nav:true,
        },
        1400:{
          items:5.60,
          nav:true,
          }
      }
    });

  jQuery('#cart-upsell').owlCarousel({
      loop:true,
      margin:10,
      nav:false,
      dots:false,
      center: false,
      autoplay:false,
      autoplayTimeout:3000,
      autoplayHoverPause:false,
      responsiveClass:true,
      responsive:{
        0:{
          items:2.70
          },
        575:{
          items:2.70
        },
        992:{
          items:3
        },
        1400:{
          items:3.7
        }
      }
    });


	// Check screen width on page load
	var screenWidth = jQuery(window).width();
	if(screenWidth > 767){
		jQuery(".ProductsSlider").owlCarousel({
			navigation : true,
			margin:24,
			items:4,
			loop:true,
			dots:false,
			nav:true,
			autoplay:false,
			autoplayTimeout:3000,
			autoplayHoverPause:true,
			autoHeight: false,
			responsive:{
				0:{
					items:2,
					dots:true,
				},
				768:{
					dots:false,
					items:2,
					margin:15,
				},
				992:{
					dots:false,
					items:3,
					margin:15,
				},
				1281:{
					dots:false,
					items:4,
				},
				1367:{
					dots:false,
					items:4,
				}
			}
		});
		jQuery(".RelatedProductsSlider").owlCarousel({
			navigation : true,
			margin:24,
			items:5,
			loop:true,
			dots:false,
			nav:true,
			autoplay:false,
			autoplayTimeout:3000,
			autoplayHoverPause:true,
			autoHeight: false,
			responsive:{
				0:{
					items:2,
					dots:true,
				},
				768:{
					dots:false,
					items:3,
					margin:15,
				},
				992:{
					dots:false,
					items:4,
					margin:15,
				},
				1281:{
					dots:false,
					items:5,
				},
				1367:{
					dots:false,
					items:5,
				}
			}
		});
	}
	
	jQuery("#RealReviewsSlider").owlCarousel({
		navigation : true,
		margin:24,
		items:3,
		loop:true,
		dots:false,
		nav:true,
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1,
				dots:false,
				margin:0,
			},
			610:{
				dots:false,
				items:2,
				margin:15,
			},
			1281:{
				dots:false,
				items:3,
			}
		}
    });

	jQuery('#pdp-images-main-slider').slick({
        dots:false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '#pdp-images-nav-slider',
		infinite: false,
    }); 
	
	jQuery('#pdp-images-nav-slider').slick({
		arrows: false,
		infinite: false,
		dots:false,
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: '#pdp-images-main-slider',
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3
				}
			}
    	]
	}); 
	jQuery(".cws_select_full").niceSelect();
    jQuery(".cws_select").niceSelect();


    jQuery(".recover-password").click(function() {
      jQuery(".login-form").hide();
      jQuery(".forgot-form").show();
    });
    
    jQuery(".back-login").click(function() {
      jQuery(".login-form").show();
      jQuery(".forgot-form").hide();
    });


	jQuery('#pdp-images-main-slider').on('afterChange', function(event, slick, currentSlide){
    
		// Pause ALL videos
		jQuery('.product-video').each(function(){
			this.pause();
			this.currentTime = 0;
		});

		// Find current slide
		var current = $(slick.$slides[currentSlide]).find('video')[0];

		// If slide has a video → play it
		if(current){
			current.play();
		}
	});


   jQuery('.corporate-logo').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        responsiveClass: true,
        responsive: {
          0: { items: 2}, 600: { items: 3, nav: true }, 1000: { items: 5, nav: true }, 1200: { items: 6, nav: true }
        }
      });

      jQuery('.corporate-testimonial').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        responsiveClass: true,
        responsive: {
          0: { items: 1 }, 600: { items: 1, nav: true }, 1000: { items: 2, nav: true }, 1200: { items: 2, nav: true }
        }
      });

      jQuery('.corporate-concierge').owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        responsiveClass: true,
        responsive: {
          0: { items: 3 }, 600: { items: 3}, 1000: { items: 4}, 1200: { items: 7}
        }
      });

  jQuery('.membership-keynotes').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    items: 1
  });


  

  jQuery('.swatch-option').on('click', function(){
     var type = jQuery(this).data("type");
     var value = jQuery(this).data("value");
     jQuery(this).closest('.swatch-attribute-options').children('.swatch-option').removeClass('selected');
     jQuery(this).addClass('selected');
     jQuery(this).closest('.swatch-attribute').children('.swatch-attribute-selected-option').text(jQuery(this).children('label').text());
     
     if(type == 'hat'){
       if(value=='trucker'){
         jQuery(".option-1-black-1-white-camo").hide();
         jQuery(".option-1-black-1-grey").hide();
         jQuery(".option-1-white-1-white-camo").hide();
         jQuery(".option-1-white-1-grey").hide();
       } else if(value=='regular'){
         jQuery(".option-1-black-1-white-camo").show();
         jQuery(".option-1-black-1-grey").show();
         jQuery(".option-1-white-1-white-camo").show();
         jQuery(".option-1-white-1-grey").show();
       }
     }
      
   });


  jQuery(document).delegate(".active-facets__button", "click", function(e) {
     jQuery("#"+jQuery(this).data("filter")).click();
  });

  jQuery(document).delegate(".open-chat", "click", function(e) {
    rep.triggerFlow({flowType: "ENTRY_FLOW", flowKey: "entrygoalconvertfromproductpage", "chatopened":true});
  });


	jQuery(document).delegate(".show-filter", "click", function(e) {
		jQuery('.collection_filter').addClass('active');
		jQuery('body').addClass('__filter-active');
	});
	jQuery(document).delegate(".close-filter", "click", function(e) {
		jQuery('.collection_filter').removeClass('active');
		jQuery('body').removeClass('__filter-active');
	});


	jQuery(document).delegate(".show_products", "click", function(e) {
		jQuery('.collection_filter').removeClass('active');
		jQuery('body').removeClass('__filter-active');
	});
	




  jQuery("#VideoSlider").owlCarousel({
		navigation : true,
		margin:24,
		items:5,
		loop:true,
		dots:false,
		center: true,
		nav:true,
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:2,
				dots:false,
				margin:8,
			},
			768:{
				dots:false,
				items:3,
				margin:15,
			},
			992:{
				dots:false,
				items:4,
				margin:15,
			},
			1281:{
				dots:false,
				items:5,
			},
			1367:{
				dots:false,
				items:5,
			}
		}
	});
	jQuery("#SendingSamples").owlCarousel({
		navigation : true,
		margin:24,
		items:3,
		loop:true,
		dots:false,
		center: true,
		nav:false,
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
		responsive:{
			0:{
				items:2,
				dots:false,
				margin:8,
			},
			768:{
				dots:false,
				items:2,
				margin:15,
			},
			992:{
				dots:false,
				items:2,
				margin:15,
			},
			1281:{
				dots:false,
				items:3,
			}
		}
	});



  jQuery(document).delegate(".lqr-video-wrap img", "click", function(e) {
   
        var url = jQuery(this).attr('videoUrl');
        var id = jQuery(this).attr('videoId');
        var html = "";
        jQuery('#tiktokVideoModal .modal-body').html("<blockquote class='tiktok-embed'> <iframe name='"+id+"' src='"+url+"' style='width: 100%; height: 620px; display: block; visibility: unset; max-height: 620px;'></iframe> </blockquote>");
        jQuery('#tiktokVideoModal').modal('show');
    });
    jQuery('#closemyModal').on('click', function(){
        jQuery('#tiktokVideoModal').modal('hide');
        jQuery('#tiktokVideoModal .modal-body').html("");
    });
  jQuery(document).delegate("#filter-new", "click", function(e) {
      jQuery('#SortBy').val('created-descending').change();
  });


  jQuery(document).delegate(".swol-banner img", "click", function(e) {
    jQuery('.pre_order').click();

  });

  jQuery(".read_more").click(function() {
        jQuery('html, body').animate({
            scrollTop: jQuery(".category-desc").offset().top - 230
        }, 500);
    });
  

	jQuery('.cws_faq_question').on('click', function() {
            var $item = jQuery(this).closest('.cws_faq_item');
            $item.toggleClass('active');
            $item.find('.cws_faq_answer').slideToggle(300);
	});
	jQuery("#_featured_slider").owlCarousel({
		navigation : false,
		items:1,
		loop:true,
		dots:true,
		nav:false,
		autoplay:false,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		autoHeight: false,
	});

  
	
});

